import {NetworkAPIVersion} from './network.utils';

export default {
  getList: {
    url: 'newspaper/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'get',
  },
};
